const HREF = window.location.href;

(function(){

    //Check Login Route
    if(HREF.includes('/login')){

        //Check Error Message
        document.addEventListener('DOMContentLoaded', function(){

            //Get Error List Element
            let errorList = document.querySelector('.alert-danger ul');

            //Check if the Error Element exist
            if(errorList){

                setTimeout(function(){

                    return document.querySelector('.alert-danger').remove();

                }, 5000);

            }

            return;

        });

        //Show Password
        document.querySelector('.showpass').addEventListener('click', function(e){

            //Check if password input is not empty
            if(document.getElementById('mailpassword').value !== ''){

                //Check conditional for show or hide password
                if(this.getAttribute('data-show') === 'true'){

                    //Change Conditional for show/hide password
                    this.setAttribute('data-show', 'false');

                    //Actived Show Password method
                    document.getElementById('mailpassword').setAttribute('type', 'text');

                    //Change action
                    this.textContent = 'hide';


                }else{

                    //Change Conditional for show/hide password
                    this.setAttribute('data-show', 'true');

                    //Actived Show Password method
                    document.getElementById('mailpassword').setAttribute('type', 'password');

                    //Change action
                    this.textContent = 'show';

                }

            }

            return;

        });

    }

})();
